import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Editor } from 'draft-js';
import _ from 'lodash';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import AlertService from '../../../../../components/SweetAlert';
import placeholderBackground from '../../../../../assets/images/placeholder-background.png';

const AddPreview = ({
  setIsPreview,
  handleSubmit,
  name,
  description,
  type,
  points,
  quantity,
  mailingPoints,
  images,
  instructions,
  collectionPoint,
  remarks,
}) => {
  return (
    <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
      <div
        className="d-flex flex-column"
        style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
      >
        <div
          style={{ cursor: 'pointer' }}
          onClick={async () => {
            (await AlertService.confirm(
              '',
              'Are you sure you want to edit this item?'
            )) && setIsPreview(false);
          }}
        >
          <i className="fas fa-chevron-left pe-2"></i> Back
        </div>
        <div className="d-flex justify-content-between pt-4">
          <h3>{name}</h3>
          <button
            className="btn btn-brand"
            style={{ width: '150px' }}
            onClick={handleSubmit}
          >
            Publish
          </button>
        </div>
      </div>
      <div
        className="d-flex"
        style={{
          marginTop: '2rem',
          marginLeft: '3rem',
          marginRight: '3rem',
        }}
      >
        <div className="flex-grow-1">
          <div className="rounded shadow bg-white">
            <div className="p-4 d-flex flex-column">
              <div className="d-flex flex-column">
                <div>
                  {
                    <Carousel showStatus={false} showThumbs={false}>
                      {images.length > 0 ? (
                        images.map((image, index) => (
                          <div
                            key={index}
                            style={{ height: '350px' }}
                            className="bg-white"
                          >
                            <img
                              style={{ maxWidth: '100%', height: '100%' }}
                              src={`${URL.createObjectURL(image)}`}
                              alt=""
                            />
                          </div>
                        ))
                      ) : (
                        <div>
                          <img src={placeholderBackground} alt="Placeholder" />
                        </div>
                      )}
                    </Carousel>
                  }
                </div>
                <div className="d-flex justify-content-between align-items-center my-3">
                  <div className="d-flex flex-column">
                    <div className="text-muted">Points to Redeem</div>
                    <h5 className="text-brand">
                      {type === 'redeemable' ? `${points} POINTS` : 'FREE'}
                    </h5>
                  </div>
                  <div
                    className="badge bg-brand text-white d-flex align-items-center justify-content-center"
                    style={{
                      height: '40px',
                      width: '120px',
                      borderRadius: '3.5rem',
                    }}
                  >
                    {quantity} left
                  </div>
                </div>
                <div className="pt-2 text-muted">Description</div>
                <Editor editorState={description} readOnly={true} />
                <div className="pt-2 text-muted">Mailing Cost</div>
                <p className="pt-2">{mailingPoints} Points</p>
                <div className="pt-2 text-muted">
                  Instructions (How to Redeem)
                </div>
                <p className="pt-2">{instructions}</p>
                <div className="pt-2 text-muted">Where to Collect</div>
                <p className="pt-2">{collectionPoint}</p>
                <div className="pt-2 text-muted">Remarks</div>
                <p className="pt-2">{remarks}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex flex-column"
          style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
        >
          {/* <strong className="mt-2">
            Redeemed (
            {
                  _.uniqBy(
                    item.redeemed.map(associate => ({
                      quantity: associate.quantity,
                      ...associate.associate
                    })),
                    'id'
                  ).length
                }
            )
          </strong> */}
          {/* {item &&
                item.redeemed.length > 0 &&
                _.uniqBy(
                  item.redeemed.map(associate => ({
                    quantity: associate.quantity,
                    ...associate.associate
                  })),
                  'id'
                ).map(associate => (
                  <div
                    key={associate.id}
                    className="d-flex align-items-center my-1 py-1 rounded"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      history.push(`/associates/associate/${associate.id}`)
                    }
                  >
                    <div className="mx-2">
                      <img
                        className="img-responsive rounded-circle border"
                        src={
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        style={{ height: '35px', width: '35px' }}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        {_.truncate(
                          `${associate.first_name} ${associate.last_name}`,
                          { length: 18 }
                        )}
                      </div>
                    </div>
                  </div>
                ))} */}
        </div>
      </div>
    </div>
  );
};

export default AddPreview;
